import { Button, ButtonProps } from '@mantine/core';
import React from 'react';

import { DeviceWarrantyType } from '@portals/api/organizations';
import { useOpenModal } from '@portals/redux';

import { UploadDeviceWarrantyModalData } from '../../../../modals';

interface UploadDeviceWarrantyButtonProps
  extends Omit<ButtonProps, 'onClick' | 'children'> {
  deviceId: string;
  warranty?: DeviceWarrantyType;
}

export function UploadDeviceWarrantyButton({
  deviceId,
  warranty,
  ...buttonProps
}: UploadDeviceWarrantyButtonProps) {
  const openModal = useOpenModal();

  return (
    <Button
      onClick={() =>
        openModal<UploadDeviceWarrantyModalData>('UploadDeviceWarrantyModal', {
          deviceId,
          warrantyToEdit: warranty,
        })
      }
      {...buttonProps}
      data-testid="upload-warranty-button"
    >
      Upload Warranty
    </Button>
  );
}
